import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppShell } from "@/components/AppShell";
import { AuthProvider } from "@/contexts/AuthContext";
import { AuthCallback } from "@/components/AuthCallback";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { PublicPageTracker } from "@/components/PublicPageTracker";
import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import OnboardingPage from "@/pages/OnboardingPage";
import OverviewPage from "@/pages/OverviewPage";
import KeywordsPage from "@/pages/KeywordsPage";
import ContentPage from "@/pages/ContentPage";
import SocialPage from "@/pages/SocialPage";
import RadarPage from "@/pages/RadarPage";
import BacklinksPage from "@/pages/BacklinksPage";
import AnalyticsPage from "@/pages/AnalyticsPage";
import ArticlesPage from "@/pages/ArticlesPage";
import ArticleDetailPage from "@/pages/ArticleDetailPage";

function ScrollToTop() {
  const location = useLocation();
  useEffect(() => { if (!location.hash) window.scrollTo({ top: 0, behavior: "instant" }); }, [location.pathname, location.hash]);
  return null;
}

function DashboardApp() {
  return <AppShell><ScrollToTop/><Routes><Route index element={<OverviewPage/>}/><Route path="keywords" element={<KeywordsPage/>}/><Route path="content" element={<ContentPage/>}/><Route path="social" element={<SocialPage/>}/><Route path="radar" element={<RadarPage/>}/><Route path="backlinks" element={<BacklinksPage/>}/><Route path="analytics" element={<AnalyticsPage/>}/></Routes></AppShell>;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback/>;
  return <><ScrollToTop/><PublicPageTracker/><Routes>
    <Route path="/" element={<LandingPage/>}/>
    <Route path="/login" element={<LoginPage/>}/>
    <Route path="/auth/callback" element={<LoginPage/>}/>
    <Route path="/onboarding" element={<ProtectedRoute onboarding><OnboardingPage/></ProtectedRoute>}/>
    <Route path="/articles" element={<ArticlesPage/>}/>
    <Route path="/articles/:slug" element={<ArticleDetailPage/>}/>
    <Route path="/app/*" element={<ProtectedRoute><DashboardApp/></ProtectedRoute>}/>
  </Routes><Toaster richColors position="top-center"/></>;
}

export default function App() {
  return <BrowserRouter><AuthProvider><AppRouter/></AuthProvider></BrowserRouter>;
}